module.exports = __webpack_public_path__ + "img/capturer-diplomat-2.d778895d.svg";